// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosRealizados_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /relatorios/servicos_realizados/lista_servicos_realizados.
 *
 * The model emits a fixed SELECT column list from the per-user view
 * `vw_lista_servicos_realizados_<userIdSansHyphens>` (built by
 * Servicos_realizados_model::criaViewXcrud()), then enriches each row with
 * the name-lookup keys franquia / tipo / nome / operador / atendente. The
 * per-row shape is concrete and typed by ServicosRealizados_ListaRow.
 */
import type { ServicosRealizados_ListaRow } from './ServicosRealizados_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicosRealizados_ListaResponseDados = ServicosRealizados_ListaRow[];

export type ServicosRealizados_ListaResponse = ApiResponse<ServicosRealizados_ListaResponseDados>;

registerResponseContract('ServicosRealizados_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      compromisso_franquia_id:      { type: 'number',  required: true },
      compromisso_operador_user_id: { type: 'string',  required: true },
      orcamento_user_id:            { type: 'string',  required: false },
      valor_no_compromisso:         { type: 'number',  required: true },
      valor_no_orcamento:           { type: 'number',  required: true },
      agendado_no:                  { type: 'string',  required: true },
      cliente_nome:                 { type: 'string',  required: false },
      servicoscategoria_id:         { type: 'number',  required: false },
      servico_id:                   { type: 'number',  required: false },
      compromisso_id:               { type: 'number',  required: true },
      compromisso_titulo:           { type: 'string',  required: true },
      compromisso_total:            { type: 'number',  required: true },
      compromisso_data_hora_inicio: { type: 'string',  required: true },
      data_compromisso:             { type: 'string',  required: true },
      franquia:                     { type: 'string',  required: false },
      tipo:                         { type: 'string',  required: false },
      nome:                         { type: 'string',  required: false },
      operador:                     { type: 'string',  required: false },
      atendente:                    { type: 'string',  required: false },
    },
  },
})
